var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "m13.016 16.66 7.017 7.013-7.017 7.013L6 23.673z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#005296",
    d: "m18.108 11.56 7.056-7.053 12.12 12.113-7.057 7.052z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "m17.779 36.242 7.18 7.265L37.28 31.03V16.502z"
  })));
};
export default SvgLogo;